import { useCallback, useContext } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { some } from 'lodash'
import { historyRead } from '../api'
import { AppStateContext } from '../state/AppProvider'

export const useOpenExperiment = () => {
  const appStateContext = useContext(AppStateContext)
  const navigate = useNavigate()
  const location = useLocation()

  const openExperiment = useCallback(
    async (experimentId: string, isViewOnly: boolean) => {
      const formattedDate = new Date().toLocaleString(undefined, {
        dateStyle: 'medium',
        timeStyle: 'short',
      })

      const conversation = await historyRead(undefined, experimentId, isViewOnly, formattedDate)
      if (!conversation) return null

      appStateContext?.dispatch({ type: 'UPDATE_CURRENT_CHAT', payload: conversation })
      appStateContext?.dispatch({ type: 'SET_SHOULD_VALIDATE_FORM', payload: false })
      if (!some(appStateContext?.state.chatHistory, chat => chat.id === conversation.id)) {
        appStateContext?.dispatch({ type: 'UPDATE_CHAT_HISTORY', payload: conversation })
      }

      if (location.pathname !== '/app') {
        navigate('/app')
      }

      return conversation
    },
    [appStateContext, navigate, location.pathname],
  )

  return { openExperiment }
}
